import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as actions from '../../core/actions/contact.actions';
import * as fromContact from '../../core/reducers/contact.reducer';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { map, startWith, delay, filter } from 'rxjs/operators';

@Component({
  selector: 'app-contact-tab',
  templateUrl: './contact-tab.component.html',
  styleUrls: ['./contact-tab.component.scss']
})
export class ContactTabComponent implements OnInit {

   public contact: any;
   
  constructor(private store: Store<any>, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
 	
 	this.activatedRoute.params.subscribe(params => {
	  	if (params && params.id) {
	  		if (params.id > 0 )	 {
  				this.store.dispatch(new actions.OpenTabAction(params.id));	  		
	  		}
	  		this.store.select(fromContact.selectOpenContacts).pipe(
	  		
	  			map((contacts: any[]) => {
          			return contacts.find(contact => {
          				if (contact.oldId && contact.oldId.toString() === params.id.toString()) {
          					return true;
          				}
            		return contact.id.toString() === params.id.toString();
          			})
	  			}),
	  			filter(c => c && !c.loading)
	  		).subscribe(c => {
	  			this.contact = c;
	  			console.log('popopo', this.contact);
	  		}
	  		);
	    }
	});
  }
}
